import {Component, Input, OnInit} from '@angular/core';
import {CustomerContact, CustomerContactService, CustomerService, Ref} from '@lifeislife/lifeislife-domain';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, publishReplay, refCount, switchMap} from 'rxjs/operators';

@Component({
  selector: 'cf-customer-contact-item',
  templateUrl: './customer-contact-item.component.html',
  styleUrls: ['./customer-contact-item.component.scss'],
})
export class CustomerContactItemComponent implements OnInit {

  @Input()
  set ref(value: Ref<CustomerContact>) {
    this.refSource$.next(value);
  }

  private refSource$ = new BehaviorSubject<Ref<CustomerContact>>(null);

  customerLabel$: Observable<string>;
  roleLabel$: Observable<string>;

  constructor(
    private customerContactService: CustomerContactService,
    private customerService: CustomerService,
  ) {
  }

  ngOnInit(): void {
    const customerContact$ = this.refSource$.pipe(
      switchMap(ref => this.customerContactService.getCustomerContact$(ref)),
      publishReplay(1), refCount(),
    );

    this.customerLabel$ = customerContact$.pipe(
      switchMap(c => c == null ? null : this.customerService.getCustomerLabel$(c.customerRef)),
      publishReplay(1), refCount(),
    );

    this.roleLabel$ = customerContact$.pipe(
      switchMap(c => this.customerContactService.getContactTypeModel$(c.customerContactType)),
      map(c => c == null ? null : c.label),
      publishReplay(1), refCount(),
    );
  }

}
